export const blurVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);

    v_texCoord = a_texCoord;
}
`;

// https://www.shadertoy.com/view/Xltfzj
export const blurFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

uniform vec2 u_resolution;
uniform float u_blurSize;  // BLUR SIZE (Radius)

uniform sampler2D u_texture0;

#define PI2 radians(360.0)

out vec4 outColor;

void main() {
  float directions = 16.0; // BLUR DIRECTIONS (Default 16.0 - More is better but slower)
  float quality = 3.0; // BLUR QUALITY (Default 4.0 - More is better but slower)
  float size = 8.0; // BLUR SIZE (Radius)
  
  vec2 radius = u_blurSize / u_resolution;
  
  vec4 color = texture(u_texture0, v_texCoord);
  
  for(float d = 0.0; d < PI2; d += PI2 / directions) {
    for(float i = 1.0 / quality; i <= 1.0; i += 1.0 / quality) {
      color += texture(u_texture0, v_texCoord + vec2(cos(d), sin(d)) * radius * i);
    }
  }


  color /= quality * directions - 15.0;

  outColor = color;
}`;
